import React, { Component } from 'react';

export default class Reset extends Component {
	constructor(props) {
		super(props);
		this.state = {
			page: 0,
			emailError: false
		};
	}

	changePage = (page) => {
		this.setState({ page: page })
	}

	sendResetEmail = () => {
		this.props.setResetData('response', false)
		if (!this.props.data.Email.length > 3 || !this.props.data.Email.includes('@') || !this.props.data.Email.includes('.')) {
			this.setState({ emailError: 'Invalid Email Format Provided' })
		} else {
			this.setState({ emailError: '' })
			fetch(window.location.origin + window.location.pathname + 'sendresetemail', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
				if (response.status == 200) {
					this.changePage(1)
				} else {
					this.setState({ emailError: await response.text() })
				}

			})
		}
	}
	parseQueryForHeader = (data) => {
		if (data.token) {
			console.log(data.token)
			this.props.setResetData('token', data.token)
			this.changePage(2)
			//window.location.search = '';

		}
	}
	confirmResetSMS = () => {
		fetch(window.location.origin + window.location.pathname + 'confirmresetsms', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				//this.props.navigate('Reset')
				//window.location.search = '';
				this.props.setResetData('PhoneConfirmation', '')
				this.changePage(5)
			} else {
				this.setState({ smsError: await response.text() })
			}
		})
	}
	completeReset = () => {
		this.props.data.Prescriber_ID = this.props.data.NPI
		fetch(window.location.origin + window.location.pathname + 'confirmreset', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.setState({ passwordError: "Your password has been reset succesfully" })
				this.changePage(6)
			} else {
				this.setState({ passwordError: await response.text() })
			}

		})
	}

	render() {
		console.log(this.props.data)

		if (this.props.data.response == 'invalid') {
			return (
				<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
					<h3 style={{ textAlign: 'center' }}>Your reset token has either timed out or has already been used. Please try again. </h3>
					<hr />
					<p>Enter the email address associated with your account. If you continue to have trouble please contact support.</p>
					<input type="text" key="Email" value={this.props.data.Email} onChange={(e) => { this.props.setResetData('Email', e.currentTarget.value) }} />
					{this.state.emailError ? <div className="error">{this.state.emailError}</div> : ''}
					<div className="button" onClick={this.sendResetEmail}>Continue</div>
				</div>
			)
		}
		else if (this.state.page == 5) {
			return (
				<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
					<h3 style={{ textAlign: 'center' }}>Enter a new Password</h3>
					<hr />
					<h5 style={{ padding: '0px 15px', maxWidth: '500px', textAlign: 'justify', color: '#555', fontWeight: 300 }}>Password must be at least 14 characters long and contain at least one letter, one number, and one special character. You may not use the last 10 passwords.</h5>



					<p>Password</p>
					<input type="password" value={this.props.data.ResetPassword} onChange={(e) => { this.props.setResetData('ResetPassword', e.currentTarget.value) }} />
					{this.state.passwordError ? <div className="error">{this.state.passwordError}</div> : ''}
					<div className="button" style={this.props.data.ResetPassword && this.props.data.ResetPassword.length > 8 ? {} : { backgroundColor: '#888' }} onClick={this.completeReset}>Reset Password</div>
				</div>
			)
		}
		else if (this.state.page == 6) {
			return (
				<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
					<h3 style={{ textAlign: 'center' }}>Your password has been reset succesfully. </h3>
					<hr />
				</div>
			)
		}
		else if (this.props.data.response == 'valid') {
			return (
				<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
					<h3 style={{ textAlign: 'center' }}>Confirm Phone Number</h3>
					<hr />

					<h5 style={{ padding: '0px 15px', maxWidth: '500px', textAlign: 'justify', color: '#555', fontWeight: 300 }}>A confirmation text message has been sent to the phone number associated with this account. Please enter the confirmation code in the box below.</h5>

					<p>Phone Number Confirmation Code</p>
					<input type="text" value={this.props.data.PhoneConfirmation} onChange={(e) => { this.props.setResetData('PhoneConfirmation', e.currentTarget.value) }} />
					{this.state.smsError ? <div className="error">{this.state.smsError}</div> : ''}
					<div className="button" style={this.props.data.PhoneConfirmation && this.props.data.PhoneConfirmation.length == 6 ? {} : { backgroundColor: '#888' }} onClick={this.confirmResetSMS}>Confirm</div>
				</div>
			)
		}
		else if (this.state.page == 0) {
			return (
				<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
					<h3 style={{ textAlign: 'center' }}>Reset your password. </h3>
					<hr />
					<p>Enter the email address associated with your account.</p>
					<input type="text" key="Email" value={this.props.data.Email} onChange={(e) => { this.props.setResetData('Email', e.currentTarget.value) }} />
					{this.state.emailError ? <div className="error">{this.state.emailError}</div> : ''}
					<div className="button" onClick={this.sendResetEmail}>Continue</div>
				</div>
			);
		} else if (this.state.page == 1) {
			return (
				<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
					<h3 style={{ textAlign: 'center' }}>If we have a record of that account, an e-mail has been sent with a link to reset your password. </h3>
					<hr />
				</div>
			)
		}


	}
}